import {BackendApi} from "./httpClient/backendApi";
import {Event} from "../../store/models";

export const rematchLastRound = async (eventId: string): Promise<Event | null> => {
    const response = await BackendApi.getInstance().instance
        .post<{ event: Event }>(
            `/events/${eventId}/rounds/rematch`,
        );

    if (!response.data) {
        return null;
    }

    return response.data.event;
}
